import { render, staticRenderFns } from "./NuevoDescuento.vue?vue&type=template&id=7aa44cec&"
import script from "./NuevoDescuento.vue?vue&type=script&lang=js&"
export * from "./NuevoDescuento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports